/** Parsed newsletter metadata object (same shape as search `NewsletterPost`). */
export function parseNewsletterMetadataObject(
  metadata: unknown,
): Record<string, unknown> | null {
  if (metadata == null) return null;
  try {
    const html = JSON.stringify(metadata);
    const jsonString = JSON.parse(html) as unknown;
    const jsonObject =
      typeof jsonString === "string"
        ? (JSON.parse(jsonString) as Record<string, unknown>)
        : (jsonString as Record<string, unknown>);
    return jsonObject && typeof jsonObject === "object" ? jsonObject : null;
  } catch {
    if (typeof metadata === "object" && metadata !== null) {
      return metadata as Record<string, unknown>;
    }
    return null;
  }
}

/**
 * Extract newsletter HTML body from post metadata — same parsing as {@link NewsletterPost}.
 */
export function parseNewsletterDescriptionHtml(metadata: unknown): string | undefined {
  const meta = parseNewsletterMetadataObject(metadata);
  const d = meta?.description;
  return d != null && String(d).trim() !== "" ? String(d) : undefined;
}

/**
 * Newsletter card title — same sources as search (`NewsletterPost` uses `caption`).
 * Does not use email HTML body (that belongs in the modal only).
 */
export function resolveNewsletterTitle(post: Record<string, unknown>): string {
  for (const key of ["caption", "content_title"]) {
    const value = String(post[key] ?? "").trim();
    if (value) return value;
  }

  const meta = parseNewsletterMetadataObject(post.metadata);
  if (meta) {
    for (const key of ["subject", "title"]) {
      const value = String(meta[key] ?? "").trim();
      if (value) return value;
    }
  }

  return "Newsletter";
}
